// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CollapsibleMenuList_wrapper__N0OFp","trigger":"CollapsibleMenuList_trigger__OjIS1","list":"CollapsibleMenuList_list__ahJmc","link":"CollapsibleMenuList_link__GbM7o"};